<template>
  <base-layout :load="loading">
    <h3 v-if="client" slot="title">
      {{ $t('commons.customer.single') }} : {{ client.name }}
    </h3>

    <client-form
      v-if="client"
      ref="form"
      :client="client"
      @validate="isValid = $event"
    ></client-form>

    <cs-button
      slot="footer"
      icon-type="material"
      icon="chevron_left"
      @click="$router.push({ name: 'indexClient' })"
    >
      {{ $t('commons.cancel') }}
    </cs-button>
    <cs-button
      slot="footer"
      type="primary"
      icon-type="material"
      icon="save"
      :loading="saving"
      :disabled="!isValid"
      @click="saveClient"
    >
      {{ $t('commons.save') }}
    </cs-button>
  </base-layout>
</template>
<script>
import { mapActions } from 'vuex';
import ClientForm from './forms/ClientForm';

export default {
  name: 'ClientEdit',
  components: { ClientForm },
  data: () => ({
    loading: false,
    saving: false,
    isValid: false,
  }),
  computed: {
    client() {
      const cl = this.$store.getters.clients.items[this.$route.params.id];
      if (!cl) return {};
      return cl;
    },
  },
  async mounted() {
    await this.get({
      type: 'client',
      id: this.$route.params.id,
    });
    this.loading = false;
  },
  methods: {
    ...mapActions(['get', 'patch']),
    async saveClient() {
      this.saving = true;
      await this.patch({
        type: 'client',
        id: this.client.id,
        data: this.client,
      });
      this.saving = false;
    },
  },
};
</script>
